import { createContext, useContext, ReactNode } from 'react'
import { useCachedTags } from '@hooks/useCachedTags'
import { useAuthStore } from '@store/authStore'
import type { TagDto, TagCategoryDto, TagType } from '@features/adventures/types/adventure-editor.types'

interface TagsContextValue {
  tags: Map<string, TagDto>
  categories: TagCategoryDto[]
  isLoading: boolean
  error: string | null
  getTag: (tagId: string) => TagDto | undefined
  getTags: (tagIds: string[]) => TagDto[]
  getCategoriesByType: (tagType: TagType) => TagCategoryDto[]
  getAdventureCategories: () => TagCategoryDto[]
  refresh: () => Promise<void>
}

const TagsContext = createContext<TagsContextValue | undefined>(undefined)

export function TagsProvider({ children }: { children: ReactNode }) {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated)
  const tagsData = useCachedTags(isAuthenticated)

  return <TagsContext.Provider value={tagsData}>{children}</TagsContext.Provider>
}

export function useTags() {
  const context = useContext(TagsContext)
  if (context === undefined) {
    throw new Error('useTags must be used within a TagsProvider')
  }
  return context
}
